import type { paths } from './codegen/system.types'
import { HOST } from '@/globals/typescript/utils/host'
import { i18n } from '@/locales'
import { useUserStore } from '@/stores/userStore'
import { createLabApiClient } from '@team-milva/lab-utils'
import { getCurrentUserBearer } from './getCurrentUserBearer'
import { reportApiTransportFailure } from '@/globals/typescript/utils/reportError'

export const systemApi = createLabApiClient<paths>({
  baseUrl: () => `${HOST.functions}/system/v1`,
  defaultHeaders: () => {
    return {
      'Accept-Language': i18n.global.locale.value,
      // Only set while an admin is impersonating a real employee (Mode
      // User) — empty for Mode Self/None. See userStore's
      // `impersonationApiHeaders` getter.
      ...useUserStore().impersonationApiHeaders,
    }
  },
  getBearerToken: getCurrentUserBearer,
  onTransportFailure: (info) => reportApiTransportFailure('system', info),
})

